import { createCompoundComponent, Drawer } from '@lounge-fe/ui-kit'
import { NavigationDrawer as BaseNavigationDrawer } from './NavigationDrawer'
import { Link } from './Link'
import { Content } from './Content'

export const NavigationDrawer = createCompoundComponent(BaseNavigationDrawer, {
  Content,
  Drawer,
  Link,
})
